
import { tx, lz } from "@/i18n";export const LINEN_ITEMS = lz([
  { key: "compleet_1p", label: "Compleet 1p" },
  { key: "compleet_2p", label: "Compleet 2p" },
  { key: "hoeslaken_1p", label: "Hoeslaken 1p" },
  { key: "hoeslaken_2p", label: "Hoeslaken 2p" },
  { key: "overtrek_1p", label: "Overtrek 1p" },
  { key: "overtrek_2p", label: "Overtrek 2p" },
  { key: "kussensloop", label: "Kussensloop" },
  { key: "kussenmolton", label: "Kussenmolton" },
  { key: "molton_1p", label: "Molton 1p" },
  { key: "molton_2p", label: "Molton 2p" },
  { key: "molton_baby", label: "Molton baby" },
  { key: "hoeslaken_baby", label: "Hoeslaken baby" },
  { key: "overtrek_baby", label: "Overtrek baby" },
  { key: "kussensloop_baby", label: "Kussensloop baby" },
  { key: "handdoek_gr", label: "Handdoek GR" },
  { key: "handdoek_kl", label: "Handdoek KL" },
  { key: "badlaken", label: "Badlaken" },
  { key: "badmat", label: "Badmat" },
  { key: "gastendoekje", label: "Gastendoekje" },
  { key: "washandje", label: "Washandje" },
  { key: "vaatdoek", label: "Vaatdoek" },
  { key: "theedoek", label: "Theedoek" },
  { key: "handdoekje", label: "Handdoekje" },
  { key: "dweil", label: "Dweil" },
]);

export const LINEN_LABELS = lz(LINEN_ITEMS.reduce((acc, x) => ({ ...acc, [x.key]: x.label }), {}));
